var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm btn-info mr-1 mb-1",attrs:{"disabled":!_vm.data || !_vm.data.length},on:{"click":_vm.exportCallFeeOverview}},[_c('i',{staticClass:"fa fa-download"}),_vm._v("\r\n    "+_vm._s(_vm.$t('export'))+"\r\n  ")])
}
var staticRenderFns = []

export { render, staticRenderFns }